@if (!environment.production) {
  <button mat-mini-fab (click)="showPanel()" [class]="{ active: devMode.isImpersonating() }" aria-label="Dev Tool">
    <mat-icon>settings</mat-icon>
  </button>
}
